import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StatsBar from './components/StatsBar';
import WhatIsVerdict from './components/WhatIsVerdict';
import AdminPortal from './components/AdminPortal';
import CandidatePortal from './components/CandidatePortal';
import Features from './components/Features';
import TechSpecs from './components/TechSpecs';
import HowItWorks from './components/HowItWorks';
import CaseStudies from './components/CaseStudies';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import DataSheet from './components/DataSheet';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './styles/globals.css';
import { BrowserRouter } from 'react-router-dom';

export default function App() {
  const [activeSection, setActiveSection] = useState('home');

  return (
    <BrowserRouter basepath="/microsite/">
      <Navbar activeSection={activeSection} setActiveSection={setActiveSection} />
      <Hero setActiveSection={setActiveSection} />
      <StatsBar />
      <WhatIsVerdict />
      <AdminPortal />
      <CandidatePortal />
      <Features />
      <TechSpecs />
      <HowItWorks />
      <CaseStudies />
      <Testimonials />
      <Pricing />
      <DataSheet />
      <Contact />
      <Footer setActiveSection={setActiveSection} />
    </BrowserRouter>
  );
}